// Video Popup 
const fabricExternalPlayVideos = document.querySelectorAll('.external-video__container--fabric');
const fabricVideoPopup = document.querySelector('.external-video__video-popup--fabric');

// Open Popup
fabricExternalPlayVideos.forEach(el => el.addEventListener('click', function(e) {
  console.log(e);
  const targetSection = e.target.closest(".external-video__container").dataset.section;
  const targetvideoLink = document.querySelector('.external-video__url[data-section="' + targetSection + '"]').innerText;

  const videoHTML = `
  <div class="external-video__video-container">
    <div class="external-video__video">
      <iframe 
        src="${targetvideoLink}" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>
  </div>`;

  fabricVideoPopup.innerHTML = '';
  fabricVideoPopup.classList.remove('hidden');
  fabricVideoPopup.classList.add('videoIsAdded');
  fabricVideoPopup.insertAdjacentHTML('beforeend', videoHTML);
}))

// Close popup
const closefabricVideoPopup = function() {
  fabricVideoPopup.classList.add('hidden');
  fabricVideoPopup.innerHTML = '';
}

fabricVideoPopup.addEventListener('click', closefabricVideoPopup);


window.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closefabricVideoPopup();
});